import Icon from 'components/elements/Icon'

import { CardType } from 'types/deck'

import styles from './customCardMarker.module.scss'

type Props = {
  card: CardType
}

const CustomCardMarker = ({ card }: Props) => {
  if (!card.customCard) return null

  return (
    <div className={styles.container} title="User custom card. (Not a real MTG card)">
      <span className={styles.cornerQuantity}>
        <Icon name="file image outline" />
      </span>
    </div>
  )
}

export default CustomCardMarker
